export default Object.freeze({
  FIXED: 'fixed',
  PERCENTAGE: 'percentage',
  MIXED: 'mixed',
});

